import {connect} from 'react-redux';
import LoginForm from './LoginForm';
import {setUser, login} from 'modules/Auth/actions';

export default connect(
  null,
  {setUser, login}
)(LoginForm);
